import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7500Model } from "../kymw7500.model";

type GetPlanGoodsFeatureResponse = {
  FeatureCode: string;
  FeatureName: string;
}[];

/**
 * 企画商品特集情報を取得するサービス
 *
 * @export GetPlanGoodsFeatureService
 * @class GetPlanGoodsFeatureService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanGoodsFeatureService extends PlessJsonResponderSub<GetPlanGoodsFeatureResponse> {
  private model: KYMW7500Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanGoodsFeatureService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.searchParams.orderCode,
        MediumType: this.model.searchParams.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPlanGoodsFeatureService
   */
  execute(model: KYMW7500Model, successFunc?: () => void) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getPlanGoodsFeature', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetPlanGoodsFeatureService 
   */
  success(data: GetPlanGoodsFeatureResponse) {
    this.model.featureList = [
      // blankを追加
      { code: '', name: '' },
      ...data.map(feature => ({
        code: feature.FeatureCode,
        name: `${feature.FeatureCode}:${feature.FeatureName}`
      }))];

    if (!!this.successFunc) {
      this.successFunc();
    }
  }
} 